import React from "react";
import { Field, Input, Textarea } from "@fluentui/react-components";

/**
 * Editor for a multilingual string object like { en: "...", fr: "..." }.
 * One field per language in `languages`.
 */
export default function MultilingualText({
  label,
  value,
  onChange,
  languages = ["en", "fr"],
  multiline = false,
  placeholder,
  disabled,
}) {
  const safeValue = value && typeof value === "object" ? value : {};

  const update = (lang, text) => {
    onChange({ ...safeValue, [lang]: text });
  };

  return (
    <Field label={label} className="field-style">
      <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
        {languages.map((lang) => {
          const langUpper = lang.toUpperCase();
          return multiline ? (
            <Textarea
              key={lang}
              value={safeValue[lang] || ""}
              onChange={(_, d) => update(lang, d.value)}
              placeholder={`${langUpper} — ${placeholder || ""}`}
              disabled={disabled}
              resize="vertical"
            />
          ) : (
            <Input
              key={lang}
              value={safeValue[lang] || ""}
              onChange={(_, d) => update(lang, d.value)}
              placeholder={`${langUpper} — ${placeholder || ""}`}
              disabled={disabled}
              contentBefore={<span style={{ color: "#888", fontSize: 12 }}>{langUpper}</span>}
            />
          );
        })}
      </div>
    </Field>
  );
}
